/* dsp-sticky-atc.js — under 990px, shows a fixed bottom bar whenever the main Add to cart button is
   out of view. Mirrors the button's label/disabled state and the current variant price. No animation. */
(function () {
  'use strict';
  var mq = window.matchMedia('(max-width: 989px)');

  function setup(bar) {
    if (bar.dataset.ready) return;
    bar.dataset.ready = '1';

    var sectionId = bar.dataset.section;
    var submit = document.getElementById('ProductSubmitButton-' + sectionId);
    var button = bar.querySelector('[data-dsp-sticky-submit]');
    var priceSource = document.getElementById('price-' + sectionId);
    var priceTarget = bar.querySelector('[data-dsp-sticky-price]');
    var scope = bar.closest('product-info') || document.body;
    if (!submit || !button) return;

    var outOfView = false;

    function syncPrice() {
      if (!priceSource || !priceTarget) return;
      var el =
        priceSource.querySelector('.price--on-sale .price-item--sale') ||
        priceSource.querySelector('.price__regular .price-item--regular') ||
        priceSource.querySelector('.price-item');
      if (!el) return;
      var text = el.textContent.replace(/\s+/g, ' ').trim();
      if (text && priceTarget.textContent !== text) priceTarget.textContent = text;
    }

    function syncButton() {
      var disabled = submit.hasAttribute('disabled') || submit.getAttribute('aria-disabled') === 'true';
      if (button.disabled !== disabled) button.disabled = disabled;
      var label = submit.querySelector('span');
      if (label) {
        var text = label.textContent.replace(/\s+/g, ' ').trim();
        if (text && button.textContent.trim() !== text) button.textContent = text;
      }
    }

    function update() {
      var show = mq.matches && outOfView;
      if (show) {
        bar.removeAttribute('hidden');
        document.documentElement.classList.add('dsp-sticky-atc-visible');
      } else {
        bar.setAttribute('hidden', '');
        document.documentElement.classList.remove('dsp-sticky-atc-visible');
      }
    }

    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          outOfView = !entry.isIntersecting;
        });
        update();
      }, { threshold: 0 }).observe(submit);
    }

    if (mq.addEventListener) mq.addEventListener('change', update);
    else if (mq.addListener) mq.addListener(update);

    button.addEventListener('click', function () {
      if (submit.disabled) return;
      submit.click();
    });

    new MutationObserver(function () {
      syncPrice();
      syncButton();
    }).observe(scope, { childList: true, subtree: true, attributes: true, attributeFilter: ['disabled', 'aria-disabled'] });

    syncPrice();
    syncButton();
  }

  function init() {
    document.querySelectorAll('[data-dsp-sticky-atc]').forEach(setup);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
